import zod from 'zod';
import { zodLimit, zodPage } from './helpers';

export const GuardianAppSchemas = {
    GuardianAppUsers: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
    }),
    GuardianAppUser: zod.object({
        id: zod.coerce.number().optional(),
    }),
};
